import React from "react";
import type { ISvgProps } from "components/icons/shared_props";
import { MAIN_THEME } from "styles/theme";

export default function Checkmark({
  size = MAIN_THEME.iconSize.small,
  color = MAIN_THEME.colors.brandWhite,
}: ISvgProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.0255 0.423385L5.75035 11.2123L1.97488 7.24806C1.79184 7.05586 1.49504 7.05586 1.31195 7.24806L0.207109 8.40814C0.0240625 8.60034 0.0240625 8.91198 0.207109 9.10422L5.41887 14.5766C5.60192 14.7688 5.89871 14.7688 6.0818 14.5766L17.7932 2.27955C17.9763 2.08735 17.9763 1.77571 17.7932 1.58347L16.6884 0.423385C16.5054 0.231186 16.2086 0.231186 16.0255 0.423385Z"
        fill={color}
      />
    </svg>
  );
}
